/** biome-ignore-all lint/suspicious/noConsole: <explanation> */
/** biome-ignore-all lint/performance/noBarrelFile: <explanation> */
/** biome-ignore-all lint/performance/noReExportAll: <explanation> */

import { Environment } from '@cobliteam/react-environments';
import { datadogRum } from '@datadog/browser-rum';

export * from './DatadogTrack';
export * from './types';

const env = Environment.getInstance().getEnvironment();

export const DEFAULT_ALLOWED_TRACING_URLS = ['https://api.cobli.co', 'https://api-beta.cobli.co'];

export default ({ configuration, user }: { configuration: any; user: any }) => {
  const { ddRUMapplicationId, ddRUMclientToken } = env;

  if (!(ddRUMapplicationId && ddRUMclientToken)) {
    console.warn('Datadog RUM AppID and/or Client Token was not found in the ENV vars!');
    return;
  }

  datadogRum.init({
    ...configuration,
    applicationId: ddRUMapplicationId,
    clientToken: ddRUMclientToken,
    site: 'datadoghq.com',
    silentMultipleInit: true,
    allowedTracingOrigins: DEFAULT_ALLOWED_TRACING_URLS,
  });
  datadogRum.setUser(user);
  datadogRum.startSessionReplayRecording();
};
